<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-9 padding-right-5px">
      <div class="card my-profile-form margin-top-15px top-link">
        <div class="card-header wh-header padding-bottom-6px">
          <div class="row">
            <div class="col-md-2 margin-top-3px">
             Approvals List
            </div>
            <div class="col-md-9 padding-right-0px">
              <div class="row">
                <div class="col-md-1 col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">From :</label>
                </div>
                <div class="col-md-2 padding-left-0px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="col-md-1 col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">To :</label>
                </div>
                <div class="col-md-2 padding-left-0px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d1.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="col-md-1 padding-left-0px">
                  <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px" (click)="Go()">Go</button>
                </div>
                <div class="col-md-3 float-right  padding-l-0px display-inherit">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  <!--<button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>-->
                  <!--<form novalidate="" #f="ngForm" class="display-inherit">
      <div class="clear-form">
        <input type="text" class="form-control" placeholder="Search"  maxlength="15">
        <a  class="nav-link-hand" title="Clear" ><span class="clear-icon"><i class="fa fa-times"></i></span></a>
      </div>
      <button  class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
    </form>-->
                </div>
                <div class="col-md-2 float-right padding-right-0px padding-l-0px display-inherit my-profile-form">
                  <div class="form-group margin-bottom-0px">
                    <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                             
                                             (searchKeyChange)="SearchKeyAssign($event)"
                                             [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode"
                                             required>
                    </CustomDataByRequestType>
                    </div>
                    <!--<button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>-->
                    <!--<form novalidate="" #f="ngForm" class="display-inherit">
      <div class="clear-form">
        <input type="text" class="form-control" placeholder="Search"  maxlength="15">
        <a  class="nav-link-hand" title="Clear" ><span class="clear-icon"><i class="fa fa-times"></i></span></a>
      </div>
      <button  class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
    </form>-->
                  </div>
                </div>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px margin-left-0px">

          <div class="row">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero width-100pe"
                         cols="auto,2*,*,*,*,*,*,*">
                  
                      <!--<caption class="font-size-14px background-primary">{{l.BranchName}}</caption>-->

                      <thead class="">
                        <tr>

                          <th class="min-width-24px padding-top-4px padding-bottom-4px">
                            Code
                          </th>
                          <!--<th class="text-align-center">Day</th>-->
                          <!--<th class="text-align-center">
        Old Reg No
      </th>-->
                          <th class="padding-top-4px padding-bottom-4px">
                            Patient
                          </th>
                          <!--<th class="text-align-center">Start Time</th>-->
                          <th class="padding-top-4px padding-bottom-4px">
                            Bill No
                          </th>

                          <!--<th class="">
        Prime Relation
      </th>-->

                          <th class="padding-top-4px padding-bottom-4px">
                            Req Date
                          </th>
                          <th class="padding-top-4px padding-bottom-4px">
                            Refundable
                          </th>
                          <th class="padding-top-4px padding-bottom-4px">
                            Req Amt
                          </th>
                          <th class="padding-top-4px padding-bottom-4px">
                            Approved Amt
                          </th>
                          <th class="padding-top-4px padding-bottom-4px">
                            Approved on
                          </th>

                          <th class="padding-top-4px padding-bottom-4px">
                            Status
                          </th>




                        </tr>
                      </thead>

                      <tbody class="table-body">

                        <tr *ngFor="let l of pdata" (click)="DisplaySelected(l)">

                          <td class="td-padding-tb"> <a (click)="RefundItems(l.RefundRequestCode)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>{{l.RefundRequestCode}}</a></td>
                          <!--<td class="td-padding text-align-center">Mon</td>-->
                          <!--<td class="td-padding text-align-center">

        {{l.PatientRegistrationNumber}}
      </td>-->

                          <td class=" td-padding-tb">
                            {{l.PatientName}}
                          </td>


                          <!--<td class="td-padding text-align-center"></td>-->
                          <td class=" td-padding-tb">
                            {{l.BillNo}}
                          </td>
                          <!--<td class=" td-padding-tb ">{{l.PrimeRelation}}</td>-->



                        <td class="td-padding-tb">{{l.RefundRequestDate| date:'MMM-dd-yyyy'}}</td>

                          <td class="td-padding-tb  text-align-right">{{l.RefundTotal}}</td>
                          <td class="td-padding-tb  text-align-right">
                            {{l.RequestedAmount}}
                          </td>
                          <td class="td-padding-tb  text-align-right ">{{l.ApprovedAmount}}</td>
                          <td class="td-padding-tb ">{{l.ApprovedDate| date:'MMM-dd-yyyy'}}</td>
                          <td class="td-padding-tb text-align-center">
                           
                            <div [ngSwitch]="l.RequestStatus">

                              <!--<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
      <i *ngSwitchCase="'Assigned'"
         class="fas fa-circle color-Assign nav-link-hand font-size-14">
        A
      </i>
    </a>-->
                              <!--<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
      <i *ngSwitchCase="'Assigned'"
         class="fas fa-circle color-Assign nav-link-hand font-size-14">
        A
      </i>
    </a>-->


                              <a data-toggle="tooltip" data-placement="bottom" title="Approved">
                                <!--<i *ngSwitchCase="'Assigned'"-->
                                <i *ngSwitchCase="'APRVD'"
                                   class="fas fa-circle color-default nav-link-hand font-size-14">
                                </i><!--{{l.ApplicationStatus}}-->
                              </a>
                              
                              
                              



                              
                              
                            </div>
                          </td>

                          <!--<td class="td-padding-tb">
        <div class="row">
          <a (click)="edit_(l)" class="nav-link-hand education-navlink" title="edit">
            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
          </a>
          <a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" title="Remove">
            <span class="badge">
              <i class="far fa-trash-alt"></i>
            </span>
          </a>

        </div>
      </td>-->



                        </tr>

                      </tbody>
                  
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 padding-left-5px padding-top-15px background-dashboard" *ngIf="DetailsSection">
      <div class="card    top-link height-100pe card-background-transparent">
        <div class="card-body padding-top-0px margin-left-0px">

          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">Refund Details</label>
            </div>
            <div class="col-md-12" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-16px color-Assign margin-bottom-0px">{{SelectedpatientDetails.PatientName}}</h4>
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.PatientGender}},{{SelectedpatientDetails.PatientAgeY}}</h4>
              <h4 class="font-size-13px margin-bottom-3px">{{SelectedpatientDetails.PatientFormattedRegCode}}</h4>
              <h4 class="font-size-13px margin-bottom-3px">{{SelectedpatientDetails.PatientPhoneNumber}}</h4>
            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12" >
              <label class="margin-bottom-0px font-size-12px">Refund #</label>
            </div>
            <div class="col-md-12" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-16px color-Assign margin-bottom-0px">{{SelectedpatientDetails.RefundRequestCode}}</h4>
            </div>
            <div class="col-md-12" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.RefundType}}</h4>
            </div>

          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">Requested By</label>
            </div>
            <div class="col-md-12" >
              <h4 class="font-size-16px color-Assign margin-bottom-0px">{{SelectedpatientDetails.RefundRequestedUserName}}</h4>
            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-13px margin-bottom-0px">Req Amount : {{SelectedpatientDetails.RequestedAmount}}</h4>
            </div>
            <div class="col-md-12 margin-top-3px">
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.RefundRequestDate | date:'MMM-dd-yyyy'}}</h4>
            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.RefundReason}}</h4>
            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <!--<label class="margin-bottom-0px font-size-12px">1st Approval</label>-->
              <button type="button" class="btn btn-secondary font-size-13px  actions-btn-prime-badge margin-right-5px  margin-top-3px background-blue">1st Approval</button>

            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-16px color-Assign margin-bottom-0px">

                <i class="fas fa-circle color-default nav-link-hand font-size-14" *ngIf="SelectedpatientDetails.FirstLevelApproved">
                </i>
                <i class="fas fa-circle color-Rejected nav-link-hand font-size-14" *ngIf="!SelectedpatientDetails.FirstLevelApproved">
                </i>
                {{SelectedpatientDetails.FirstLevelApprovedUser}}
              </h4>
            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <!--<label class="margin-bottom-0px font-size-12px">2nd Approval</label>-->
              <button type="button" class="btn btn-secondary font-size-13px  actions-btn-prime-badge margin-right-5px  margin-top-3px background-blue">2nd Approval</button>
            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-16px color-Assign margin-bottom-0px">
                <i class="fas fa-circle color-default nav-link-hand font-size-14" *ngIf="SelectedpatientDetails.SecondLevelApproved">
                </i>
                <i class="fas fa-circle color-Rejected nav-link-hand font-size-14" *ngIf="!SelectedpatientDetails.SecondLevelApproved">
                </i>
                {{SelectedpatientDetails.SecondLevelApprovedUser}}
              </h4>
            </div>
            <div class="col-md-12 margin-top-3px">
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.ApprovedDate | date:'MMM-dd-yyyy'}}</h4>
            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-13px margin-bottom-0px">Aproval Amount : {{SelectedpatientDetails.RefundTotal}}</h4>
            </div>
            <div class="col-md-12 margin-top-3px" *ngIf="SelectedpatientDetails">
              <h4 class="font-size-13px margin-bottom-0px">{{SelectedpatientDetails.RefundReason}}</h4>
            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">{{SelectedpatientDetails.PayerName}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 padding-left-8px margin-top-3px" *ngIf="SelectedpatientDetails">
              <button type="button" class="btn btn-secondary btn-raised  margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px margin-right-5px" (click)="RefundItems(SelectedpatientDetails.RefundRequestCode)"><i class="far fa-folder-open margin-right-3px folder-color"></i>Open</button>
              <button class="btn actions-btn-prime  font-size-13px margin-right-5px">Approve</button>
              <button class="btn actions-btn-prime font-size-13px margin-right-5px">Reject</button>
            </div>
            <!--<div class="col-md-4">
             
              <button class="btn actions-btn-prime  font-size-13px ">Approve</button>

            </div>
            <div class="col-md-4">
              <button class="btn actions-btn-prime font-size-13px">Reject</button>
            </div>-->
          </div>
        </div>

      </div>
      
    </div>
  </div>
 

</div>


